import { CreatePortal } from "./create";
import { UI_ACTION_PORTAL_ID } from "./constants";

export default function HeaderPortal({ children, className }) {
  return (
    <CreatePortal to={UI_ACTION_PORTAL_ID} className={className}>
      {children}
    </CreatePortal>
  );
}
